/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import PasswordConfirmation from 'shared/ui/components/form-components/PasswordConfirmation.vue';

/**
 * This component is the user's password form.
 *
 * @vue-prop {Object} user the current user object
 *
 * @example
 * ````
 * UserPassword(:user="user" v-slot="{ updating }")
 * ```
 *
 * @category ui.pages.profile.user-profile
 * @exports UserPassword
 * @component
 */
const __vue_script__ = {
    name: 'UserPassword',

    components: { BaseInput, PasswordConfirmation },

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            passwd: {
                oldPassword: '',
                newPassword: '',
            },
            error: null,
            updateInProgress: false,
        };
    },

    methods: {
        async update() {
            this.error = null;

            const valid = await this.$refs.form.validate();

            if (!valid) {
                return;
            }

            this.updateInProgress = true;

            try {
                await this.$services.account.changePassword(this.passwd.oldPassword, this.passwd.newPassword);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('profile.details.form.password_change_success').toString(),
                    type: 'success',
                });
            } catch (error) {
                const response = error.response;
                const data = response.data;

                console.info(response);

                let message = error.message;

                if (response.status === 409) {
                    message = this.$i18n.t('profile.details.form.password_change_reused').toString();

                    this.error = message;
                } else {
                    const errorType = data.error;

                    message = data.reason;

                    if (errorType === 'Wrong Password') {
                        this.error = this.$i18n.t('profile.details.form.wrong_password');
                    } else {
                        this.error = this.$i18n.t('profile.details.form.password_change_fail');
                    }
                }

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('profile.details.form.password_change_fail').toString(),
                    text: message,
                    type: 'error'
                });
            } finally {
                this.updateInProgress = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "form",
    staticClass: "user-password-form",
    attrs: { tag: "form", autocomplete: "off" },
    on: {
      submit: function ($event) {
        $event.preventDefault()
        return _vm.update()
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var invalid = ref.invalid
            return [
              _vm.error
                ? _c("p", { staticClass: "alert alert-danger" }, [
                    _vm._v(_vm._s(_vm.error)),
                  ])
                : _vm._e(),
              _c("input", {
                staticClass: "hidden",
                attrs: {
                  type: "text",
                  name: "username",
                  autocomplete: "username",
                },
                domProps: { value: _vm.user.email },
              }),
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: _vm.$t("profile.details.form.current_password"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("base-input", {
                            attrs: {
                              label: _vm.$t(
                                "profile.details.form.current_password"
                              ),
                              autocomplete: "current-password",
                              type: "password",
                              name: "oldPass",
                              errors: errors,
                            },
                            model: {
                              value: _vm.passwd.oldPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.passwd, "oldPassword", $$v)
                              },
                              expression: "passwd.oldPassword",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("password-confirmation", {
                attrs: {
                  "password-label": _vm.$t("profile.details.form.new_password"),
                  "confirm-label": _vm.$t(
                    "profile.details.form.confirm_new_password"
                  ),
                },
                model: {
                  value: _vm.passwd.newPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.passwd, "newPassword", $$v)
                  },
                  expression: "passwd.newPassword",
                },
              }),
              _vm._t("default", null, { updating: _vm.updateInProgress }),
              _c("secondary-toolbar", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "submit",
                      disabled: _vm.updateInProgress || invalid,
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("profile.details.update_password")))]
                ),
              ]),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/user/UserPassword.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__